import React from "react";
import { Link } from "react-router-dom";
import "../css/navbar.css";
import { ReactComponent as SearchIcon } from "../assets/icons/nav/input-search-icon.svg";
import { ReactComponent as MenuIcon } from "../assets/icons/nav/menu.svg";
import { ReactComponent as DropDown } from "../assets/icons/nav/blue-dropdown.svg";
import { ReactComponent as WorldIcon } from "../assets/icons/nav/world-icon.svg";

const Navbar = () => {
  return (
    <nav>
      <section id="lp-navbar">
        <div>
          <ul>
            <li id="logo">
              <Link to="/">Logo</Link>
            </li>
            <li id="subjects">
              <MenuIcon id="all-subject-menu" />
              <span>All Subjects</span>
            </li>
            <li id="search">
              <SearchIcon id="search-icon" />
              <input
                type="text"
                id="subject-search"
                name="all-subjects"
                placeholder="Search..."
              />
            </li>
            <li>
              <Link to="/for-parents">For Parents</Link>
            </li>
            <li>
              <Link to="/for-teachers">For Teachers</Link>
            </li>
          </ul>
          <ul>
            <li id="country">
              <WorldIcon id="world-icon" />
              <div>
                <span id="title">Country</span>
                <div id="country-dd">
                  <span id="country-name">Nigeria</span>
                  <DropDown id="drop" />
                </div>
              </div>
            </li>
            <li>
              <button>Login</button>
            </li>
            <li>
              <button>Sign up</button>
            </li>
          </ul>
        </div>
      </section>
    </nav>
  );
};

export default Navbar;
